import { createContext, useContext, ReactNode } from 'react';

type Side = 'left' | 'right';

type CardWrapperContextType = {
  side: Side;
};

const CardWrapperContext = createContext<CardWrapperContextType | null>(null);

const useCardWrapper = () => {
  const context = useContext(CardWrapperContext);
  if (!context) {
    throw new Error(
      'CardWrapper components must be used within CardWrapper.Root'
    );
  }
  return context;
};

type RootProps = {
  side: Side;
  children: ReactNode;
  className?: string;
};

const Root = ({ side, children, className = '' }: RootProps) => {
  return (
    <CardWrapperContext.Provider value={{ side }}>
      <div className={`flex flex-col gap-4 md:flex-row ${className}`}>
        {children}
      </div>
    </CardWrapperContext.Provider>
  );
};

type SlotProps = {
  children: ReactNode;
  className?: string;
};

const Primary = ({ children, className = '' }: SlotProps) => {
  const { side } = useCardWrapper();

  const orderClass = side === 'left' ? 'order-2 md:order-1' : 'order-2 md:order-2';

  return (
    <div className={`w-full md:w-[60%] ${orderClass} ${className}`}>
      {children}
    </div>
  );
};

const Secondary = ({ children, className = '' }: SlotProps) => {
  const { side } = useCardWrapper();

  const orderClass = side === 'left' ? 'order-1 md:order-2' : 'order-1 md:order-1';

  return (
    <div className={`w-full md:w-[40%] ${orderClass} ${className}`}>
      {children}
    </div>
  );
};

const CardWrapper = {
  Root,
  Primary,
  Secondary,
};

export default CardWrapper;
